import { Component, OnInit } from "@angular/core";
import { Producto } from "../../../../model/class/Producto";
import * as _ from "lodash";
import { ProductoService } from "../../../services/producto/producto.service";

@Component({
  selector: "app-historial-cambios-productos",
  templateUrl: "./historial-cambios-productos.component.html",
  styleUrls: ["./historial-cambios-productos.component.css"],
  providers: [],
})
export class HistorialCambiosProductosComponent implements OnInit {
  loader = {
    tabla: true,
  };

  public options = {
    creados: 'creados',
    actualizados: 'actualizados',
  };

  public range = {
    tresmeses: 'tresmeses',
    seismeses: 'seismeses',
    unano: 'unano',
    siempre: 'siempre',
  };

  optionSelected = this.options.creados;
  rangeSelected = undefined;

  productosTodos: Producto[] = [];

  headerTable: any = {
    creados: [
      {
        text: "Foto",
      },
      {
        text: "Nombre",
        value: "nombre",
      },
      {
        text: "Códigos",
        value: "totalCodigos",
      },
      {
        text: "Estatus",
        value: "estado",
      },
      {
        text: "Creado",
        value: "creadoPor",
      },
      {
        text: "Creado por",
        value: "createdBy",
      },
    ],
    actualizados: [
      {
        text: "Foto",
      },
      {
        text: "Nombre",
        value: "nombre",
      },
      {
        text: "Códigos",
        value: "totalCodigos",
      },
      {
        text: "Estatus",
        value: "estado",
      },
      {
        text: "Actualizado",
        value: "fecModificacion",
      },
      {
        text: "Actualizado por",
        value: "modificadoPor",
      },
    ]
  };

  constructor(private productoService: ProductoService) {
    this.optionSelected = this.options.creados;
    this.rangeSelected = this.range.tresmeses;
  }

  ngOnInit() {
    this.productoService.getHistorialCambios(this.optionSelected, this.rangeSelected).subscribe((data) => {
      for (const p of data) {
        this.productosTodos.push(new Producto(p));
      }
      this.loader.tabla = false;
    });
  }

  ordenar() {
    this.obtenerHistorial();
  }

  rango() {
    this.obtenerHistorial();
  }

  obtenerHistorial() {
    this.productosTodos = [];
    this.loader.tabla = true;
    this.productoService.getHistorialCambios(this.optionSelected, this.rangeSelected).subscribe((data) => {
      for (const p of data) {
        this.productosTodos.push(new Producto(p));
      }
      this.loader.tabla = false;
    });
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/historial-cambios-productos/historial-cambios-productos.component.ts